<template>
	<div>
		<div class="xs-12 mt6">
			<div class="block mb2">
				<span class="fw7">Reason A</span> - The country where the Account Holder
				is liable to pay tax does not issue TINs to its residents (example
				Cayman Islands does not issue a TIN).
			</div>
			<div class="block mb2 lh125">
				<span class="fw7">Reason B</span> - The Account Holder has applied for a
				TIN or equivalent number. If you select Reason B, you agree to provide
				Sun Life with your TIN or equivalent number within 30 days of receiving
				it from the applicable tax authority.
			</div>
			<div class="block mb2 lh125">
				<span class="fw7">Reason C</span> - A TIN is not required to be provided
				on this form. (Note: Select Reason C ()f)/x_ if the tax authority of the
				jurisdiction of tax residence entered on the table above has enacted
				local law which does not require a TIN to be provided for purposes of
				OECD CRS.)
			</div>
			<div class="block lh125">
				<span class="fw7">Reason D</span> - The Account Holder has not applied
				for a TIN or equivalent number or is unable to obtain a TIN or
				equivalent number. If you select Reason D, please explain why in the box
				below:
			</div>
		</div>
		<!-- Form -->
		<!-- Q1 -->
		<div class="xs-12 fs4 fw7 mt6 mb2">Tax Residency</div>
		<case-form
			v-for="i in 3"
			:key="i"
			:schema="schemaTaxResidency(i)"
			class="mb6"
		/>
		<!-- Add Button -->
		<j-button type="primary" @click="numberOfRows++" v-if="numberOfRows !== 3"
			>Add</j-button
		>

		<case-form :schema="schemaOthers" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
import JButton from "@/components/JButton"

export default {
	components: {
		CaseForm,
		JButton
	},

	computed: {
		schemaOthers() {
			return [
				{
					label:
						"Please check this box to confirm the tax residence(s) provided above include all jurisdictions of tax residence applicable to this Account Holder",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasProvidedApplicableTax`,
					props: {
						suggest: {
							typeIncludes: `hasProvidedApplicableTax`
						},
						createOptions: {
							type: `hasProvidedApplicableTax`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: `If Reason D was selected, please explain why below`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdernoTaxpayerIdentificationNumberReason`,
					props: {
						suggest: {
							typeIncludes: `noTaxpayerIdentificationNumberReason`
						},
						createOptions: {
							type: `noTaxpayerIdentificationNumberReason`,
							dataType: "string"
						}
					}
				},
				{
					label: `Is the Account Holder identified on Line 1 a Specified U.S. Person {see Appendix 1 for definition of Specified U.S. Person)?`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderisSpecifiedUSPerson`,
					props: {
						suggest: {
							typeIncludes: `isSpecifiedUSPerson`
						},
						createOptions: {
							type: `isSpecifiedUSPerson`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: `Please provide an explanation as to why the Account Holder maintains a residence or mailing address in the
country but does not consider himself/herself a tax resident for tax purpose of this country:`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderdifferentResidentAndMailingAddressReason`,
					props: {
						suggest: {
							typeIncludes: `differentResidentAndMailingAddressReason`
						},
						createOptions: {
							type: `differentResidentAndMailingAddressReason`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaTaxResidency(i) {
			return [
				{
					label: `Jurisdiction of tax residence ${i}`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderjurisdictionOfTaxResidence${i}`,
					props: {
						suggest: {
							typeIncludes: `jurisdictionOfTaxResidence${i}`
						},
						createOptions: {
							type: `jurisdictionOfTaxResidence${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Taxpayer Identification Number (TIN) ${i}`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdertaxpayerIdentificationNumber${i}`,
					props: {
						suggest: {
							typeIncludes: `taxpayerIdentificationNumber${i}`
						},
						createOptions: {
							type: `taxpayerIdentificationNumber${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `If TIN is unavailable, enter Reason A, B, C, or D as
provided in the instructions above
(and if you select Reason D, please provide an explanation)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdernoTaxpayerNumber${i}`,
					props: {
						suggest: {
							typeIncludes: `noTaxpayerNumber${i}`
						},
						createOptions: {
							type: `noTaxpayerNumber${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
